import React, { useState, useRef, useEffect } from 'react';
import './modalinformativo.css';

const ModalInformativo = ({ isOpen = false, onClose = () => {}, onAccept = () => {}, titulo = '', contenido = '' }) => {
  const [hasReadAll, setHasReadAll] = useState(false);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setHasReadAll(false);
    }
  }, [isOpen]);

  const handleScroll = (e) => {
    const element = e.target;
    const isAtBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 10;
    if (isAtBottom) {
      setHasReadAll(true);
    }
  };

  if (!isOpen) {
    return null;
  }

  const handleAccept = () => {
    if (hasReadAll) {
      onAccept();
      onClose();
    }
  };

  return (
    <div className="modal-informativo-overlay" onClick={onClose}>
      <div className="modal-informativo-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-informativo-close" onClick={onClose}>✕</button>
        
        <h2 className="modal-informativo-title">{titulo}</h2>
        
        <div className="modal-informativo-body" ref={scrollContainerRef} onScroll={handleScroll}>
          <p className="modal-informativo-text">{contenido}</p>
        </div>
        
        <button 
          className={`modal-informativo-accept-btn ${!hasReadAll ? 'disabled' : ''}`}
          onClick={handleAccept}
          disabled={!hasReadAll}
        >
          {!hasReadAll ? 'Lee todo para continuar' :  'Acepto'}
        </button>
      </div>
    </div>
  );
};

export default ModalInformativo;
